import { destination } from "@turf/turf";

/**
 * ある地点から指定半径内に指定戸数のランダムな地点を生成する
 * @param {number} latitude 
 * @param {number} longitude 
 * @param {number} radius 
 * @param {number} count 
 * @returns 
 */
export function generateRandomPoints(latitude, longitude, radius, count) {
  const randomPoints = [];
  for (let i = 0; i < count; i++) {
    const distance = Math.random() * radius;
    const angle = Math.random() * 360;
    const destinationPoint = destination(
      [longitude,latitude],
      distance,
      angle,
      { units: "meters" }
    );
    const [lng, lat] = destinationPoint.geometry.coordinates;
    randomPoints.push({ lat, lng });
  }
  return randomPoints;
}
